export function clampPointsToSpend(
  value: number,
  walletBalance: number,
  maxPointsRedeemable: number,
): number {
  const max = Math.min(walletBalance, maxPointsRedeemable)
  if (max <= 0) {
    return 0
  }

  return Math.max(0, Math.min(value, max))
}

export function maxPointsToSpend(
  walletBalance: number,
  maxPointsRedeemable: number,
): number {
  return Math.max(0, Math.min(walletBalance, maxPointsRedeemable))
}
